module.exports = __webpack_public_path__ + "img/icon-type-profile.c33faea4.svg";